import React from 'react';

import './Stretch.scss';

function Stretch() {
  return <div styleName="stretch" />;
}

export default Stretch;
